var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-center',{attrs:{"caption":"パスワードを変更する","action":_vm.changePassword,"disabled":_vm.disabled}})}
var staticRenderFns = []

export { render, staticRenderFns }